module.exports = __webpack_public_path__ + "img/share-2.7c7332c0.svg";